import { useState, useCallback } from 'react';

export const useEditorPanel = () => {
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [editorMode, setEditorMode] = useState('create');
  const [editorTemplate, setEditorTemplate] = useState(null);

  const openEditor = useCallback((mode, template = null) => {
    setEditorMode(mode);
    setEditorTemplate(template);
    setIsEditorOpen(true);
  }, []);

  const closeEditor = useCallback(() => {
    setIsEditorOpen(false);
    setEditorMode('create');
    setEditorTemplate(null);
  }, []);

  return { isEditorOpen, editorMode, editorTemplate, openEditor, closeEditor };
};